import { t } from '@ctcells/i18n'

import { cx } from './cx.ts'
import { Icon } from './Icon.tsx'

import './feedback.css'

/**
 * 「못 봤다」 한 덩이 — 조회가 **막혔거나 실패한** 자리에 선다.
 *
 * 🔴 **`EmptyState`(0건)와 생김새가 달라야 한다.** 2026-09-22 실측: viewer 의 시료 표가
 *    「권한이 없습니다」를, 검색 0건인 표가 「시료 없음」을 **똑같은 회색 한 줄**로 그리고
 *    있었다. 글자를 안 읽으면 둘이 구분되지 않는다 — 「못 봤다」가 「없다」로 읽히면
 *    사람이 **있는 것을 없다고 믿는다**(CLAUDE.md 「못 봤다를 0건으로 접지 마라」).
 * 🔴 색만으로 가르지 않는다 — **글리프 · 머리말 · 면**이 같이 말한다. `:root`(다른 앱 4개)는
 *    강조·위험색이 무채색이라 색이 빠져도 글리프와 머리말이 남는다.
 *
 * 톤은 두 가지다.
 *   `blocked` 막힘(권한 없음 · 잠김) — 지금 확정된 사실이다. 차분한 면
 *   `failed`  실패(통신 오류 · 5xx)  — 다시 하면 달라질 수 있다. 위험색 띠
 */
export type StateNoticeTone = 'blocked' | 'failed'

export type StateNoticeProps = {
  /** 사유 문장. 서버가 준 까닭을 그대로 싣는다 */
  reason: string
  /** 기본 `blocked`. 통신 실패·5xx 는 `failed` */
  tone?: StateNoticeTone | undefined
}

export function StateNotice({ reason, tone = 'blocked' }: StateNoticeProps) {
  return (
    <div
      className={cx('a-notshown', tone === 'failed' && 'a-notshown--failed')}
      role={tone === 'failed' ? 'alert' : 'status'}
    >
      <Icon name={tone === 'failed' ? 'alert' : 'blocked'} size="md" />
      <span className="a-notshown__text">
        <strong className="a-notshown__head">{t('state.notShown')}</strong>
        <span className="a-notshown__why">{reason}</span>
      </span>
    </div>
  )
}
